import { useEffect } from 'react';

import {
  closeCurrentModal,
  openDialogAsync,
  openModal,
} from '~/utils/mobileApp';
import { BUSINESS_REGISTER_URL } from '~/utils/url';

import ErrorPage from './ErrorPage';

const C1UserErrorPage = () => {
  useEffect(() => {
    void (async () => {
      await openDialogAsync({
        type: 'action',
        title: '사업장 등록',
        description:
          '캐시노트 마켓은 사업장이 등록된 사장님만 이용할 수 있어요',
        confirmText: '사업장 등록하기',
      });

      openModal({
        url: BUSINESS_REGISTER_URL,
      });
    })();
  }, []);

  return <ErrorPage resetText="되돌아가기" onResetClick={closeCurrentModal} />;
};

export default C1UserErrorPage;
